<template>
  <IconsLoader size="md" class="app-loader" v-if="showLoader"/>
  <v-layout v-else align-center column class="reset-staff-password-container" :style="{ backgroundColor: pageBackground}">
    <GoToHomepage class="homepage" :is-branded="isBranded" :branding="branding"/>
    <ResetPassword
      :includedFields="includedFields"
      :resetButtonText="$t('common.login.passwords.set_password')"
      :title="$t('common.login.passwords.welcome_staff_title')"
      :sub-title="$t('common.login.passwords.staff_sub_title_instructions')"
      :btnLoading="inProgress"
      @click="setStaffPassword"
    />
  </v-layout>
</template>

<script>
import ResetPassword from "./ResetPassword";
import {mapGetters} from "vuex";
import {authService} from '@/modules/auth/services/authService.js';
import GoToHomepage from '@/modules/auth/components/GoToHomepage';
import {IconsLoader} from "@/modules/common/components";

export default {
  name: "SetStaffPassword",
  components:{ResetPassword, GoToHomepage, IconsLoader},
  data(){
    return{
      inProgress: false,
      showLoader: true
    }
  },
  props: {
    authToken: {
      type: String,
      required: true
    }
  },
  async created(){
    let response = await authService.verifyStaffToken({auth_token: this.authToken})
    if(response && !response.valid){
      this.goToForgotPassword()
    }
    this.showLoader = false
  },
  computed:{
    ...mapGetters(['isMobile']),
    ...mapGetters("brandModule", ["branding","isBranded"]),
    includedFields(){
      return {
        confirmationPassword: false
      }
    },
    pageBackground(){
      if (this.isBranded) return this.branding.primary_color
    },
  },
  methods:{
    async setStaffPassword(params){
      this.inProgress = true
      let response = await authService.setStaffPassword({authentication_token:this.authToken, password:params.password})
      if(response && response.success){
        let data =  response.data;
        if(data && data.message && data.message.password_set){
          let email = data.message.email
          let loginResult = await authService.login({resetPassword: true, password: params.password, username: email, email: email})
          if(loginResult && loginResult.success === false){
            if(loginResult.error === 'server_error'){
              this.showServerError = true
            }
            this.inProgress = false
          }
        }
      }
      else{
        this.inProgress = false
      }
    },
    goToForgotPassword() {
      this.$router.push({name: "forgotpassword", params: {shouldDisplayLinkInvalidMessage: true}});
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.app-loader {
  position: fixed;
  z-index: 1;
  top: 0;
}

.reset-staff-password-container{
  height: 100vh;
  @include md-and-up{
    padding-top: 10vh;
    background: rgba(245, 250, 253, 1);
  }

  .homepage {
    margin-top: 10px;
    margin-bottom: 10px;
    @include md-and-up{
      margin-bottom: 58px;
    }
  }

}


</style>
